import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { DepartmentDto } from '~/models/modules/department';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class DepartmentsService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.assets);
  }

  getDepartmentGrid(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<any[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }


  createDepartment(model : any){
    return this.client.post<any>(this._url(), model);
  }


  updateDepartment(id: number, model : any){
    return this.client.put<any>(this._url(`/${id}`), model);
  }


  getDepartmentById(id : number){
    return this.http.get<DepartmentDto>(this._url(`/${id}`));
  }

  deactivateDepartment(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }
  deactivatePatchDepartment(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
  }


  reactivateDepartment(id: number) {
    return this.client.put(this._url(`/reactivate/${id}`), null);
  }
  reactivateBatchDepartment(obj: any) {
    return this.client.put(this._url(`/batchReactivate`), obj);
  }

  async getDepartments() {
    return this.http.get<any>(this._url(`/departments`));
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Departments${v}`);
  }
}
